export const getOfferText = (form) => {
    // First try to get the offer text from the form's default CTA
    const defaultCta = form?.getAttribute('data-default-cta') || '';
    // console.log('Default CTA from form:', defaultCta);

    // If we have a default CTA, use it
    if (defaultCta) {
        return cleanOfferText(defaultCta);
    }

    // Then try to get the offer text from the form's offer text attribute
    const offerText = form?.getAttribute('data-offer-text') || '';
    // console.log('Offer text from form:', offerText);

    if (offerText) {
        return cleanOfferText(offerText);
    }

    // Then try to get it from the global nvData object
    const globalOfferText = window.nvData?.defaultCta || '';
    // console.log('Global offer text:', globalOfferText);

    if (globalOfferText) {
        return cleanOfferText(globalOfferText);
    }

    // Return empty string instead of fallback
    return '';
};

const cleanOfferText = (text) => {
    if (!text) return '';

    // First remove any prefix patterns
    text = text.replace(/^(?:Limited-Time Offer:|Hurry, \d+ days? left:)\s*/i, '');

    // Try to extract the offer amount with LASIK
    const offerMatch = text.match(/\$[\d,]+(?:\s+off\s+LASIK)/i);
    if (offerMatch) {
        return offerMatch[0];
    }

    // If no match found, try just the dollar amount
    const dollarMatch = text.match(/\$[\d,]+/);
    if (dollarMatch) {
        return dollarMatch[0] + ' off LASIK';
    }

    // If no matches found, return the cleaned text or empty string
    return text.trim() || '';
};
